export default {
    "color-1": "#D32F2F",
    "color-2": "#EF5350",
    "color-3": "#C2185B",
    "color-4": "#EC407A",
    "color-5": "#7B1FA2",
    "color-6": "#AB47BC",

    "color-7": "#512DA8",
    "color-8": "#7E57C2",
    "color-9": "#303F9F",
    "color-10": "#5C6BC0",
    "color-11": "#1976D2",
    "color-12": "#42A5F5",

    "color-13": "#0288D1",
    "color-14": "#29B6F6",
    "color-15": "#0097A7",
    "color-16": "#26C6DA",
    "color-17": "#00796B",
    "color-18": "#26A69A",

    "color-19": "#388E3C",
    "color-20": "#81C784",
    "color-21": "#689F38",
    "color-22": "#AED581",
    "color-23": "#9E9D24",
    "color-24": "#D4E157",

    "color-25": "#FBC02D",
    "color-26": "#FFEB3B",
    "color-27": "#FFA000",
    "color-28": "#FFCA28",
    "color-29": "#F57C00",
    "color-30": "#FFAB40",

    "color-31": "#F4511E",
    "color-32": "#FF7043",
    "color-33": "#6D4C41",
    "color-34": "#8D6E63",
    "color-35": "#616161",
    "color-36": "#BDBDBD",

    "color-37": "#546E7A",
    "color-38": "#90A4AE",
    "color-39": "#03549D",
    "color-40": "#0274BF",
    "color-41": "#81DC47",
    "color-42": "#52D595",

    "color-43": "#49AF07",
    "color-44": "#7ED321",
    "color-45": "#FF1744",
    "color-46": "#FF5252",
    "color-47": "#C51162",
    "color-48": "#FF4081"
};
